"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
function addStringListToKeySet(keySet, list) {
    for (var _i = 0, list_1 = list; _i < list_1.length; _i++) {
        var value = list_1[_i];
        keySet[value] = true;
    }
}
exports.addStringListToKeySet = addStringListToKeySet;
function stringListToKeySet(list) {
    var keySet = {};
    if (list) {
        addStringListToKeySet(keySet, list);
    }
    return keySet;
}
exports.stringListToKeySet = stringListToKeySet;
function keySetToStringList(keys) {
    var list = [];
    for (var key in keys) {
        if (keys.hasOwnProperty(key)) {
            list.push(key);
        }
    }
    return list;
}
exports.keySetToStringList = keySetToStringList;
function getKeySetSize(keys) {
    var size = 0;
    for (var key in keys) {
        if (keys.hasOwnProperty(key)) {
            size++;
        }
    }
    return size;
}
exports.getKeySetSize = getKeySetSize;
//# sourceMappingURL=ItemsSet.js.map